//route page routes
export const ROUTE_HOME = '/';
export const ROUTE_LOG_IN = '/login';
export const ROUTE_SIGN_UP = '/signup';
export const ROUTE_ACCOUNT = '/account';
export const ROUTE_PASSWORD_FORGET = '/password-forget';
export const ROUTE_PASSWORD_RESET = '/password-reset';

//hashes
export const HASH_HOME_HEADER = '/#header';
export const HASH_HOME_ABOUT = '/#about';
export const HASH_HOME_TESTIMONIES = '/#testimonies';
export const HASH_HOME_SPIRIT = '/#spirit';
export const HASH_HOME_MINDSET = '/#mindset';
export const HASH_HOME_EXERCISE = '/#exercise';
export const HASH_HOME_NUTRITION = '/#nutrition';

export const ROUTE_PRINCIPLE_SPIRIT = '/principles/spirit';
export const ROUTE_PRINCIPLE_MINDSET = '/principles/mindset';
export const ROUTE_PRINCIPLE_NUTRITION = '/principles/nutrition';
export const ROUTE_PRINCIPLE_EXERCISE = '/principles/exercise';

export const ROUTE_GOAL_SETTING = '/goalsetting';

export const ROUTE_TEST = '/test';

export const ROUTE_ADMIN = '/admin/dashboard';
export const ROUTE_PLANS = '/admin/plans';

export const ADMIN = 'ADMIN';


